const $hamburger = document.querySelector('.hamburger');
const $close = document.querySelector('.cta-close');
const $overlayMenu = document.querySelector('.MobileMenu');
if ($hamburger) {

  $hamburger.addEventListener('click', (e) => {
    e.preventDefault();
    $overlayMenu.classList.add('--open');
    $hamburger.classList.add('--open');
    document.querySelector('body').style.overflow = 'hidden';
  });
}
if ($close) {
  $close.addEventListener('click', (e) => {
    e.preventDefault();
    $overlayMenu.classList.remove('--open');
    $hamburger.classList.remove('--open');
    document.querySelector('body').style.overflow = 'initial';
  });
}

$(document).ready(function() {

  $('.MobileMenu .menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();
    $(this).next('.sub-menu').toggle(200);
  });
});
